import { render } from "./CookieConsentModal.vue?vue&type=template&id=fcff4c8a"
import script from "./CookieConsentModal.vue?vue&type=script&lang=js"
export * from "./CookieConsentModal.vue?vue&type=script&lang=js"

import "./CookieConsentModal.vue?vue&type=style&index=0&id=fcff4c8a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__